module.exports = __webpack_public_path__ + "img/cart.7e8da259.svg";